import React from 'react'
import { Typography, Layout, Divider } from 'antd'

const { Title, Paragraph, Text } = Typography

const TermsFR = () => (
  <Layout style={{ padding: '1.5em 0.75em' }}>
    <Typography>
      <Title level={2} style={{ textAlign: 'center', textTransform: 'uppercase' }}>
        CONDITIONS GÉNÉRALES D'UTILISATION
      </Title>
      <Paragraph style={{ textAlign: 'center' }}>
        <Text strong>Application Web et Mobile " MusicTMM-Universum "</Text>
      </Paragraph>
      <Paragraph style={{ textAlign: 'center' }}>
        <Text type="secondary">La Politique de confidentialité fait l’objet d’un document distinct.</Text>
      </Paragraph>

      <Divider />

      <Title level={4}>1. IDENTIFICATION DE L'ÉDITEUR</Title>
      <Paragraph>
        La plateforme web et mobile " MusicTMM-Universum " (ci-après la " Plateforme ") est éditée par :
      </Paragraph>
      <Paragraph>
        <Text strong>MusicTMM SAS</Text><br />
        Société par actions simplifiée<br />
        Siège social : 99 Avenue Achille Peretti, 92200 Neuilly-sur-Seine, France<br />
        Email : <Text underline>hello@musictmm.fr</Text>
      </Paragraph>
      <Paragraph>
        La Société est titulaire des droits de propriété intellectuelle relatifs à la Plateforme.
      </Paragraph>

      <Title level={4}>2. OBJET</Title>
      <Paragraph>
        Les présentes Conditions Générales d'Utilisation (ci-après les " CGU ") ont pour objet de définir les conditions dans lesquelles la Société concède à des utilisateurs professionnels (ci-après le " Client ") un droit d'accès et d'utilisation de la Plateforme.
      </Paragraph>
      <Paragraph>
        Les CGU constituent un contrat au sens des articles 1101 et suivants du Code civil.
      </Paragraph>
      <Paragraph>
        La Plateforme est strictement réservée aux personnes morales ou aux professionnels agissant dans le cadre de leur activité commerciale.
      </Paragraph>

      <Title level={4}>3. ACCEPTATION</Title>
      <Paragraph>
        L'accès et l'utilisation de la Plateforme impliquent l'acceptation sans réserve des présentes CGU.
      </Paragraph>
      <Paragraph>
        Le Client déclare :
      </Paragraph>
      <ul>
        <li>agir à des fins professionnelles ;</li>
        <li>disposer de la capacité juridique et des pouvoirs nécessaires ;</li>
        <li>fournir des informations exactes et à jour.</li>
      </ul>

      <Title level={4}>4. DESCRIPTION DES SERVICES</Title>
      <Paragraph>
        La Plateforme permet notamment :
      </Paragraph>
      <ul>
        <li>la diffusion et la gestion de contenus musicaux dans des espaces commerciaux ;</li>
        <li>l'accès à des playlists éditoriales ou assistées par intelligence artificielle ;</li>
        <li>l'administration de comptes professionnels.</li>
      </ul>
      <Paragraph>
        La Société se réserve le droit de faire évoluer les fonctionnalités à tout moment, sous réserve d'en informer le Client en cas de modification substantielle.
      </Paragraph>

      <Title level={4}>5. LICENCE D'UTILISATION</Title>
      <Paragraph>
        La Société concède au Client une licence :
      </Paragraph>
      <ul>
        <li>non exclusive</li>
        <li>non cessible</li>
        <li>non transférable</li>
        <li>limitée à la durée du contrat</li>
      </ul>
      <Paragraph>
        La licence autorise uniquement :
      </Paragraph>
      <ul>
        <li>l'accès à la Plateforme ;</li>
        <li>l'utilisation des contenus musicaux conformément à leur destination professionnelle.</li>
      </ul>
      <Paragraph>
        Toute reproduction, extraction, reverse engineering, scraping ou exploitation non autorisée est strictement interdite.
      </Paragraph>
      <Paragraph>
        La base de données de la Plateforme est protégée conformément à la Directive 96/9/CE.
      </Paragraph>
      <Paragraph>
        L’enregistrement sur la Plateforme ne confère aucun droit d’utilisation du Service.
      </Paragraph>
      <Paragraph>
        L’accès effectif au Service est subordonné à la signature d’un contrat commercial distinct entre MusicTMM SAS et le Client.
      </Paragraph>
      <Paragraph>
        L’accès à la Plateforme, y compris l’utilisation des contenus mis à disposition, ne constitue en aucun cas une exonération des obligations légales du Client relatives au paiement des redevances susceptibles d’être dues aux sociétés de gestion collective ou aux organismes chargés de la perception des droits d’auteur et des droits voisins, conformément à la réglementation applicable dans le territoire d’exploitation.
      </Paragraph>
      <Paragraph>
        L’accès au Service est fourni à titre onéreux dans les conditions prévues au contrat commercial distinct conclu entre la Société et le Client. Les CGU ne déterminent pas les conditions tarifaires applicables.
      </Paragraph>

      <Title level={4}>6. PROPRIÉTÉ INTELLECTUELLE</Title>
      <Paragraph>
        La Plateforme, ses algorithmes, son architecture, ses contenus, marques et bases de données demeurent la propriété exclusive de MusicTMM SAS.
      </Paragraph>
      <Paragraph>
        Aucun transfert de propriété intellectuelle n'est opéré au profit du Client.
      </Paragraph>

      <Title level={4}>7. CONTENUS ASSISTÉS PAR INTELLIGENCE ARTIFICIELLE</Title>
      <Paragraph>
        Certains contenus audio disponibles sur la Plateforme peuvent inclure des éléments générés ou assistés par des technologies d'intelligence artificielle, notamment des voix synthétiques, sans que cela implique l'imitation d'un artiste réel identifié.
      </Paragraph>
      <Paragraph>
        La Société veille à respecter les exigences de transparence prévues par la réglementation européenne applicable en matière d'intelligence artificielle.
      </Paragraph>

      <Title level={4}>8. DONNÉES PERSONNELLES</Title>
      <Paragraph>
        La Société agit en qualité de Responsable du traitement au sens du Règlement (UE) 2016/679 (RGPD).
      </Paragraph>
      <Paragraph>
        Les données collectées sont traitées aux fins :
      </Paragraph>
      <ul>
        <li>de gestion des comptes professionnels ;</li>
        <li>d'exécution contractuelle ;</li>
        <li>d'amélioration des services ;</li>
        <li>de respect des obligations légales.</li>
      </ul>
      <Paragraph>
        Les modalités complètes sont détaillées dans la Politique de Confidentialité accessible sur le site officiel.
      </Paragraph>

      <Title level={4}>9. OBLIGATIONS DU CLIENT</Title>
      <Paragraph>
        Le Client s'engage à :
      </Paragraph>
      <ul>
        <li>utiliser la Plateforme conformément à sa destination professionnelle ;</li>
        <li>ne pas porter atteinte aux droits de la Société ou de tiers ;</li>
        <li>assurer la sécurité de ses identifiants ;</li>
        <li>informer sans délai la Société de tout accès frauduleux.</li>
      </ul>
      <Paragraph>
        Toute utilisation abusive pourra entraîner la suspension immédiate du service.
      </Paragraph>

      <Title level={4}>10. RESPONSABILITÉ</Title>
      <Paragraph>
        La Société est tenue d'une obligation de moyens.
      </Paragraph>
      <Paragraph>
        La responsabilité de la Société ne saurait être engagée pour :
      </Paragraph>
      <ul>
        <li>pertes indirectes ;</li>
        <li>pertes d'exploitation ;</li>
        <li>manque à gagner ;</li>
        <li>atteinte à l'image.</li>
      </ul>
      <Paragraph>
        La responsabilité totale de la Société est limitée au montant des sommes effectivement versées par le Client au cours des douze (12) derniers mois.
      </Paragraph>
      <Paragraph>
        Cette limitation s’applique également aux annexes, y compris le SLA.
      </Paragraph>
      <Paragraph>
        La présente limitation ne s'applique pas en cas de faute lourde ou intentionnelle.
      </Paragraph>

      <Title level={4}>11. DISPONIBILITÉ</Title>
      <Paragraph>
        La Société s'efforce d'assurer une disponibilité raisonnable de la Plateforme.
      </Paragraph>
      <Paragraph>
        Aucune garantie de fonctionnement ininterrompu n'est accordée.
      </Paragraph>

      <Title level={4}>12. MODIFICATION DES CGU</Title>
      <Paragraph>
        La Société peut modifier les présentes CGU.
      </Paragraph>
      <Paragraph>
        Toute modification substantielle sera notifiée au Client dans un délai raisonnable.
      </Paragraph>
      <Paragraph>
        En cas de désaccord, le Client pourra résilier son contrat.
      </Paragraph>

      <Title level={4}>13. DURÉE ET RÉSILIATION</Title>
      <Paragraph>
        Les CGU s'appliquent pour la durée de l'utilisation des services.
      </Paragraph>
      <Paragraph>
        En cas de manquement grave, la Société pourra suspendre ou résilier l'accès après mise en demeure restée sans effet.
      </Paragraph>

      <Title level={4}>14. CESSION</Title>
      <Paragraph>
        La Société peut céder tout ou partie de ses droits et obligations à toute entité de son groupe ou dans le cadre d'une opération de restructuration, fusion ou acquisition.
      </Paragraph>

      <Title level={4}>15. DROIT APPLICABLE ET JURIDICTION</Title>
      <Paragraph>
        Les présentes CGU sont régies par le droit français.
      </Paragraph>
      <Paragraph>
        Tout litige relatif à leur interprétation ou exécution relèvera de la compétence exclusive des tribunaux de Paris.
      </Paragraph>

      <Title level={4}>16. FORCE MAJEURE</Title>
      <Paragraph>
        Aucune partie ne pourra être tenue responsable d’un manquement résultant d’un cas de force majeure au sens de l’article 1218 du Code civil.
      </Paragraph>

      <Title level={4}>17. DISPOSITIONS FINALES</Title>
      <Paragraph>
        Si une clause est déclarée invalide, les autres dispositions demeureront applicables.
      </Paragraph>
      <Paragraph>
        Les CGU constituent l'intégralité de l'accord entre les parties.
      </Paragraph>
    </Typography>
  </Layout>
)

export default TermsFR
